import React from 'react';
import {View} from 'react-native';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import customStyles from '../styles';

export const BoardAccent = ({result}: {result: string}) => {
  const colorMap: Record<string, string> = {
    win: CCColors.GameReview.Green,
    loss: CCColors.GameReview.Red,
    draw: CCColors.GameReview.Rapid,
  };
  const letter = (result?.[0] ?? 'D').toUpperCase();
  const tagColor = colorMap[result?.toLowerCase()] ?? colorMap.draw;
  const cells = Array.from({length: 16});

  return (
    <View style={customStyles.boardWrap}>
      <View style={customStyles.board}>
        {cells.map((_, i) => {
          const row = Math.floor(i / 4);
          const col = i % 4;
          const isDark = (row + col) % 2 === 0;

          return (
            <View
              key={i}
              style={[
                customStyles.boardCell,
                {
                  backgroundColor: isDark
                    ? CCColors.ChessBoard.Dark
                    : CCColors.ChessBoard.Light,
                },
              ]}
            />
          );
        })}
      </View>
      <View style={[customStyles.resultTag, {backgroundColor: tagColor}]}>
        <CCText style={customStyles.resultTagText}>{letter}</CCText>
      </View>
    </View>
  );
};

export default BoardAccent;
